import React from 'react';
import { status } from '../../../utils/mappings';
// componentes:
import { Row, Col, Badge, Typography } from 'antd';

function ReportFormHeader({ templateName, reportStatus }) {
    const badgeColorByReportStatusSlug = {
        [status.RASCUNHO]: 'grey',
        [status.EDITADO]: 'orange',
        [status.NOTIFICADO]: 'blue',
        [status.FALHA_NA_NOTIFICACAO]: 'red',
        [status.HOMOLOGADO]: 'green',
        [status.AGUARDANDO_CORRECAO]: 'purple',
        [status.AGUARDANDO_MANIFESTACAO]: 'grey',
        [status.MANIFESTACAO_RECEBIDA]: 'black',
    }

    return (
        <Row style={{ marginBottom: '2rem' }}>
            <Col span={12}>
                <Typography.Title style={{ marginBottom: 2 }} level={2}>Relatório Mensal de Atividades</Typography.Title>
                <Typography>{templateName}</Typography>
            </Col>

            <Col span={12}>
                <Badge.Ribbon text={reportStatus.name} color={badgeColorByReportStatusSlug[reportStatus.slug]} />
            </Col>
        </Row>
    )
}

export default ReportFormHeader;
